import { PAYMENT_MODULE } from "@/api_framework/api_config";
import {
  IInvoiceAdjustmentRequestsData,
  IInvoiceAdjustmentRequestsParams,
} from "@/api_framework/api_modals/payment";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

interface IAPIResponse {
  status: boolean;
  message: string;
  data: IInvoiceAdjustmentRequestsData;
}

// Request history, newest first
export const useInvoiceAdjustmentRequestsAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (
      params: IInvoiceAdjustmentRequestsParams,
    ): Promise<{ status: boolean; message: IInvoiceAdjustmentRequestsData | null }> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const query: Record<string, string | number> = {
          request_type: params.request_type,
          page_number: params.page_number,
          page_size: params.page_size,
        };
        if (params.status) {
          query.status = params.status;
        }
        return await axios
          .get(PAYMENT_MODULE?.INVOICE_ADJUSTMENT_REQUESTS?.baseURL ?? "", {
            params: query,
            headers: { Authorization: `${accessToken}` },
          })
          .then((res: AxiosResponse<IAPIResponse>) => {
            if (res.data.status) {
              return { status: true, message: res.data.data };
            }
            return { status: false, message: null };
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config?.["curlCommand"]);
            captureError(e);
            return { status: false, message: null };
          });
      } catch (e) {
        captureError(e as AxiosError);
        return { status: false, message: null };
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl],
  );

  return { execute };
};
